/** Add event. */
export function addEvent() {
  // Prevent Drag/Drop event
  globalThis.addEventListener('dragover', (event) => {
    event.preventDefault();
  });
  globalThis.addEventListener('drop', (event) => {
    event.preventDefault();
  });
}
